/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: PGC编辑用户
 */
"use strict";
angular.module("editUserModule", []).
controller("editUserCtrl", ["$scope", "$element", "$validation", "$modalInstance", "httpService", "userId", "$q", "checkPhoneAndEmail", function($scope, $element, $validation, $modalInstance, httpService, userId, $q, checkPhoneAndEmail) {
	initStatus();
	initData();

	function initStatus() {
		$scope.status = {
			listData: [], //tag切换数据
			actionNum: 0, //tag默认开始选择项
			concatData: {}, //主体数据
			floatData: {}, //tag切换显示的数据
			isModile: false, //检测手机号是否存在的判断条件
			isEmail: false, //监测邮箱是否存在的判断条件
			modileRetention: '', //默认手机号
			emaileRetention: '', //默认邮箱
			bankOptions: [{ //银行选择
				name: "选择银行",
				value: 0
			}, {
				name: "工商银行",
				value: 1,
			}, {
				name: "农业银行",
				value: 2,
			}, {
				name: "中国银行",
				value: 3,
			}, {
				name: "建设银行",
				value: 4,
			}, {
				name: "交通银行",
				value: 5,
			}, {
				name: "上海浦东发展银行",
				value: 6,
			}, {
				name: "兴业银行",
				value: 7,
			}, {
				name: "光大银行",
				value: 8,
			}, {
				name: "深圳发展银行",
				value: 9,
			}, {
				name: "民生银行",
				value: 10,
			}, {
				name: "中信银行",
				value: 11,
			}, {
				name: "招商银行",
				value: 12,
			}, {
				name: "广东发展银行",
				value: 13,
			}, {
				name: "华夏银行",
				value: 14,
			}],
			mediaType: [ //媒体类型
				{
					name: '个人',
					value: 0
				},
				{
					name: '媒体',
					value: 1
				},
				{
					name: '国家机构',
					value: 2
				},
				{
					name: '企业',
					value: 3
				},
				{
					name: '其他组织',
					value: 4
				},
			]
		}
	};

	function initData() {
		requestData();
	};
	/**
	 * 取消
	 */
	$scope.cancel = function() {
		$modalInstance.dismiss();
	};

	function requestData() {
		var params = {
			id: userId,
		}
		httpService.http('/mcnadmin/admin/pgcuser/findById.do', params, 'post').then(function(res) {
			var media = res.userInfo.mediaType;
			$scope.status.listData = res.signChannels;
			$scope.status.concatData = res.userInfo;
			$scope.status.floatData = res.signChannels[0];
			$scope.status.modileRetention = $scope.status.concatData.mobile;
			$scope.status.emaileRetention = $scope.status.concatData.email;
			var d = $scope.status.bankOptions;
			for(var i = 0; i < d.length; i++) {
				if(d[i].value + '' == $scope.status.concatData.bankName) {
					$scope.status.selectedBank = angular.copy($scope.status.bankOptions[i]);
				}
			}
			var c = $scope.status.mediaType;
			for(var k = 0; k < c.length; k++) {
				if(c[k].value === $scope.status.concatData.mediaType) {
					$scope.status.selectType = angular.copy($scope.status.mediaType[k]);
				}
			}
			Drawing();
		})
	};
	/**
	 * 下载图片
	 * @param {下载地址} imgUrl 
	 */
	$scope.ondown = function(id, format) {
		downloadCanvasIamge(id, format);
	}
	/**
	 * tag页切换
	 * @param {*} num  切换参数
	 */
	$scope.actionTag = function(num) {
		$scope.status.actionNum = num;
		$scope.status.floatData = $scope.status.listData[num];
		Drawing();
	}
	/**
	 * 绘制图片：头像和身份证照片
	 */
	function Drawing() {
		var context = document.getElementById('userCanvas').getContext('2d');
		var img = new Image();
		img.onload = function() {
			context.drawImage(img, 0, 0, context.canvas.width, context.canvas.height);
		}
		img.src = $scope.status.floatData.accountLogo;

		var img2 = new Image();
		img2.onload = function() {
			var context2 = document.getElementById('cardCanvas').getContext('2d');
			context2.drawImage(img2, 0, 0, context2.canvas.width, context2.canvas.height);
		}

		img2.src = $scope.status.concatData.idNumberPic;

	}
	// 下载Canvas元素的图片
	function downloadCanvasIamge(selector, format) {
		var str = format.split('/');
		str = str[str.length - 1];
		var index = str.lastIndexOf('.');
		var endInd = str.lastIndexOf('?');
		var add;
		if(endInd == -1) {
			add = 'image/' + (str.slice(index + 1) == 'jpg' ? 'jpeg' : str.slice(index + 1));
		} else {
			add = 'image/' + (str.slice(index + 1, endInd) == 'jpg' ? 'jpeg' : str.slice(index + 1, endInd));
		}
		// 通过选择器获取canvas元素
		var canvas = document.querySelector(selector)
		// 使用toDataURL方法将图像转换被base64编码的URL字符串
		var url = canvas.toDataURL(add);
		// 生成一个a元素
		var a = document.createElement('a')
		// 创建一个单击事件
		var event = new MouseEvent('click')
		// 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
		a.download = str.slice(0, index) || '下载图片名称'
		// 将生成的URL设置为a.href属性
		a.href = url
		// 触发a的单击事件
		a.dispatchEvent(event)
	}
	/**
	 * 手机号查重
	 */
	$scope.modileQuery = function() {
		$scope.isShowTipsD = true;
		if($scope.status.concatData.mobile != '' && /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[0-9])[0-9]{8}$/.test($scope.status.concatData.mobile) && $scope.status.concatData.mobile != $scope.status.modileRetention) {
			checkPhoneAndEmail.checkPhone({
				name: 'mobile',
				param: $scope.status.concatData.mobile
			}).then(function(data) {
				if(!data) $scope.status.isModile = true;
			})
		} else {
			$scope.status.isModile = false;
		}
	}
	/**
	 * 邮箱查重
	 */
	$scope.emailQuery = function() {
		$scope.isShowTipsE = true;
		if($scope.status.concatData.email != '' && /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test($scope.status.concatData.email) && $scope.status.concatData.email != $scope.status.emaileRetention) {
			checkPhoneAndEmail.checkEmail({
				name: 'email',
				param: $scope.status.concatData.email
			}).then(function(data) {
				if(!data) $scope.status.isEmail = true;
			})
		} else {
			$scope.status.isEmail = false;
		}
	}
	/**
	 * 确定提交修改
	 */
	$scope.confirm = function() {
		if($scope.status.isModile || $scope.status.isEmail) return;
		$validation.validate($scope.editPgcUser).success(function() {
			var params = {
				userId: userId,
				mediaType: $scope.status.selectType.value,
				accountName: $scope.status.floatData.accountName,
				accountDesc: $scope.status.floatData.accountDesc,
				truename: $scope.status.concatData.userName,
				idNumber: $scope.status.concatData.idNumber,
				mobile: $scope.status.concatData.mobile,
				email: $scope.status.concatData.email,
				bankName: $scope.status.selectedBank.value,
				bankCardNumber: $scope.status.concatData.bankCardNumber,
				alipayCode: $scope.status.concatData.alipayCode,
				orgName: $scope.status.concatData.orgName,
				orgCode: $scope.status.concatData.orgCode,
				channelId: $scope.status.floatData.channelId
			}
			httpService.http('/mcnadmin/admin/pgcuser/edit.do', params, 'post').then(function(res) {
				$modalInstance.close();
			})
		}).error(function(error) {
			angular.invalidPosition($scope.editPgcUser, $element);
		});

	};
	/**
	 * [createProduct description] 初始化数据
	 * @return {[type]} [description]
	 */
	$scope.requestData = function() {
		requestData();
	};
}]);